import axiosApiInstance from '../request';
import { AxiosError } from 'axios';

interface ApiResponse<T> {
  data: T | null;
  statusCode: number;
}

interface ClientCoder {
  id: string;
  name: string;
}

interface ReportDownloadIdRes {
  report_id: string | number;
  is_successfull: boolean;
}

interface ExtendedReportDownloadIdRes extends ReportDownloadIdRes {
  file_url: string;
}

interface TransactionReport {
  id: string;
  coder_id: string;
  client_id: string;
  client_name: string;
  coder_name: string;
  amount: number;
  description: string;
  currency: string;
  job_contract: string;
  created: string;
  updated: string;
  transaction_status: string;
  type: 'DEBIT' | 'CREDIT';
  invoice: string | null;
  stripe_transaction_id: string | null;
  job_id: string;
  job_title: string;
}

interface GetTransactionParams {
  [key: string]: string;
}

const headers = { 'Content-Type': 'application/json' };

const getApiResponse = async <T>(
  url: string,
  params?: Record<string, any>
): Promise<ApiResponse<T>> => {
  const response: ApiResponse<T> = {
    data: null,
    statusCode: 500
  };

  try {
    const res = await axiosApiInstance.get(url, { headers, params });
    response.data = res.data;
    response.statusCode = res.status;
  } catch (error) {
    if (error instanceof AxiosError) {
      response.statusCode = error.response?.status || 500;
    } else {
      response.statusCode = 500;
    }
  }
  return response;
};

const getClientCoderDropdownService = async (): Promise<ApiResponse<ClientCoder[]>> => {
  return getApiResponse<ClientCoder[]>('/client-coders/');
};

const getTransactionReportService = async (
  params: GetTransactionParams
): Promise<ApiResponse<TransactionReport[]>> => {
  return getApiResponse<TransactionReport[]>('/reports/transaction-history/', params);
};

const getTransactionReportIdService = async (params: {
  coder_id?: string;
  formats: string;
}): Promise<ApiResponse<ReportDownloadIdRes>> => {
  return getApiResponse<ReportDownloadIdRes>('/reports/transaction-history/', params);
};

const getTransactionReportDownloadCsvService = async (params: {
  report_id: string | number;
}): Promise<ApiResponse<ExtendedReportDownloadIdRes>> => {
  return getApiResponse<ExtendedReportDownloadIdRes>('/reports/', params);
};

export {
  getClientCoderDropdownService,
  getTransactionReportService,
  getTransactionReportIdService,
  getTransactionReportDownloadCsvService
};
